import { useRouter } from 'next/router'
import {
  DesktopModalWrapper,
  MobileModalWrapper
} from '@smuchile/pkg-unimarc-components'
import {
  BigScreen,
  getGlobalStyle,
  SmallScreen
} from '@smuchile/pkg-unimarc-components/helpers'
import { triggerLoginEvent } from '@smuchile/pkg-unimarc-hooks'
import { ModalRegisterClubContent } from './components/ModalRegisterClubContent'
import { cleanMembershipQueryParam } from 'shared/helpers'

export const MODAL_REGISTER_CLUB_WRAPPER_ID = {
  MOBILE: 'modalRegisterClubWrapperMobile',
  DESKTOP: 'modalMembershipTypeWrapperDesktop'
}
export const ModalRegisterClubWrapper = ({
  handleToggle
}: {
  handleToggle: () => void
}): React.ReactElement => {
  const router = useRouter()

  const handleRedirect = () => {
    cleanMembershipQueryParam(router, handleToggle)
    triggerLoginEvent({
      eventType: 'loginModal',
      data: { show: true }
    })
  }
  return (
    <>
      <BigScreen>
        <DesktopModalWrapper
          blockId={MODAL_REGISTER_CLUB_WRAPPER_ID.DESKTOP}
          bodyChildrenProps={{
            padding: '0 49px'
          }}
          borderEdge='none'
          footerChildrenProps={{
            buttonDefaultProps: {
              onClick: handleRedirect,
              fontWeight: getGlobalStyle('--font-weight-medium'),
              label: 'Registrarme'
            },
            maxWidth: '400px',
            boxShadow: 'none',
            default: true
          }}
          hasfooter={true}
          headerCloseIcon={{
            customSize: 13,
            default: true
          }}
          headerTitleProps={{
            fontWeight: 'medium'
          }}
          modalConfigsProps={{
            maxWidth: '800px',
            isWindowBlocked: true,
            maxHeight: '440px',
            minHeight: '450px',
            isOpen: true,
            toggle: handleToggle,
            toggleOutside: handleToggle
          }}
          styleProps={{
            customHeightModalContent: '100%'
          }}
        >
          <ModalRegisterClubContent />
        </DesktopModalWrapper>
      </BigScreen>

      <SmallScreen>
        <MobileModalWrapper
          blockId={MODAL_REGISTER_CLUB_WRAPPER_ID.MOBILE}
          body={<ModalRegisterClubContent />}
          buttonConfigsProps={{
            onClick: handleRedirect,
            fontWeight: getGlobalStyle('--font-weight-medium'),
            label: 'Registrarme',
            isLoading: false
          }}
          dragProps={{
            draggButton: false
          }}
          hasFooter={true}
          headerCloseIconProps={{
            customSize: 13
          }}
          headerProps={{
            padding: '3px 16px'
          }}
          hideHeaderDivider={false}
          iconColor={getGlobalStyle('--color-base-black')}
          iconSize={16}
          isEnableButton
          isOpen={true}
          modalConfigsProps={{
            openAnimation: true,
            fullScreenSticky: true,
            hiddenX: true,
            isAutoHeight: true,
            isOpen: true,
            isWindowBlocked: true,
            marginFullScreen: '1vh 0 0',
            stickyBottom: true,
            toggle: handleToggle,
            toggleOutside: handleToggle
          }}
          onClose={handleToggle}
          styleProps={{
            padding: '0',
            height: '100%',
            borderRadius: `${getGlobalStyle(
              '--border-radius-md'
            )} ${getGlobalStyle('--border-radius-md')} 0 0`
          }}
        />
      </SmallScreen>
    </>
  )
}
